// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1iOBz","header":"Messages_header__2za9k"};